import { Col, Form, Input } from "antd";
import { getCostTypeConfig, getCostTypeFromPath } from "components/TransportationCost/Entry/costTypes";
import { useLocation } from "react-router-dom";
import "./TransportationCostFilterFields.css";

const TransportationCostFilterFields = () => {
  const { pathname } = useLocation();
  const { filters } = getCostTypeConfig(getCostTypeFromPath(pathname));

  return (
    <>
      {filters.map(({ name, label }) => (
        <Col span={6} key={name}>
          <Form.Item label={label} name={name} className="transportation-cost-filter-item">
            <Input size="small" placeholder={`Filter by ${label}`} allowClear />
          </Form.Item>
        </Col>
      ))}
    </>
  );
};

export default TransportationCostFilterFields;
